export default __webpack_public_path__ + "static/media/RX_Car_Lora_Thumb.d6632e26.jpg";